import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useDirection } from "shared/utils/DirectionContext";

interface Props {
  placeholder?: string;
  setData?: (time: string, keyValue?: any) => void;
  onTimeSelect?: (time: string) => void;
  onTimeChange?: (newTime: string) => void;
  defaultValue?: string;
  value?: string;
  type?: any;
  disabled?: any;
  AM?: any;
  height?: any;
  keyValue?: any;
}

const CustomTimePicker = (props: Props) => {
  const {
    placeholder,
    type,
    AM,
    setData,
    onTimeChange,
    defaultValue,
    value,
    disabled,
    height,
    keyValue,
  } = props;
  const { t, i18n }: any = useTranslation();
  const handleTimeChange = (newTime: any) => {
    if (newTime) {
      const formattedTime = dayjs(newTime).format(AM ? AM : "HH:mm");
      setData && setData(formattedTime, keyValue);
      onTimeChange && onTimeChange(formattedTime);
    }
  };
  const { isRtl } = useDirection();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        disabled={disabled}
        viewRenderers={{
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        }}
        value={
          value
            ? dayjs(value, "HH:mm")
            : defaultValue
            ? dayjs(defaultValue, "HH:mm")
            : null
        }
        ampm={AM ? true : false}
        label={placeholder}
        sx={{
          fontFamily: "inherit",
          width: "100%",
          "& .MuiStack-root": {
            overflow: "visible",
            height: height || "48px",
          },
          "& .MuiInputLabel-shrink": {
            display: "none",
          },
          "& .MuiInputLabel-root": {
            fontSize: "14px",
            color: "#7d7d7d",
            lineHeight: "28px",
            position: "absolute",
            top: "-11px",
            fontFamily: "inherit",
            left: type === "box" ? "-7px" : "-13px",
            right: isRtl ? "4%" : "0px",

            padding: "0 4px",
            zIndex: 1,
            "&.Mui-focused": {
              color: "#00276d",
            },
            "& .MuiInputLabel-shrink": {
              display: "none",
            },
          },
          "& .MuiOutlinedInput-notchedOutline":
            type == "box"
              ? {
                  alignItems: "center",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "14px",
                  color: "#999",
                  height: "48px",
                  "& legend": {
                    display: "none",
                  },
                }
              : {
                  width: "100%",
                  borderTop: "none",
                  borderRight: "none",
                  borderLeft: "none",
                  borderRadius: "0px",
                  borderBottom: "1px solid",
                  padding: "10px 0px",
                  height: "48px",
                  fontSize: "14px",
                  "& legend": {
                    display: "none",
                  },
                },
          "& .MuiIconButton-root": {
            padding: "0px",
            color: "#131313",
            right: "10px",
            marginTop: "-10px",
          },
          "& .MuiOutlinedInput-input": {
            height: type == "box" ? "" : "14px",
            color: "#7D7D7D",
            fontSize: "14px",
            paddingLeft: "0px",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "0px",
            fontSize: "14px",
            paddingLeft: type == "box" ? "10px" : "0px",
            "&:hover": {
              borderColor: "#ccc",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderWidth: type == "box" ? "1px" : "1px",
              borderColor: "#ccc",
            },
            "&.Mui-hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#ccc",
            },
          },
        }}
        onChange={handleTimeChange}
      />
    </LocalizationProvider>
  );
};

export default CustomTimePicker;
